import React from 'react';
import { View } from '@shared/components/View';
import { MBSeparator } from '@shared/components/list';
import { Colors } from '@shared/styles';
import { ChatDateStamp } from '../ChatDateStamp';

interface MBChatDateMarkerProps {
  date: string;
}

export function MBChatDateMarker({ date }: MBChatDateMarkerProps) {
  return (
    <View row center padding={2} paddingTop={4}>
      <View flex />
      <View flex style={{ opacity: 0.4 }}>
        <MBSeparator color={Colors.v2.gray50} />
      </View>
      <View paddingHorizontal={1}>
        <ChatDateStamp date={date} fontSize={13} />
      </View>
      <View flex style={{ opacity: 0.4 }}>
        <MBSeparator color={Colors.v2.gray50} />
      </View>
      <View flex />
    </View>
  );
}
